import { useEffect } from 'react'
import useEventBus from '../components/generic/useEventBus'
import { handleOfferSubmitSuccess, handlePostToParentError } from '../utils/postToParentUtils'

export const usePostToParentSubscriptions = () => {
    const conditionalOfferSubmitHandler = (eventData) => {
        handleOfferSubmitSuccess(eventData)
    }

    const conditionalErrorHandler = (eventData) => {
        handlePostToParentError(eventData)
    }

    // Subscribe to OfferSubmitSuccess which now contains the leadForm data
    useEventBus('OfferSubmitSuccess', conditionalOfferSubmitHandler)
    useEventBus('PostToParentError', conditionalErrorHandler)

    useEffect(() => {
        console.log('Post-to-parent EventBus subscriptions initialized via hook')

        return () => {
            console.log('Post-to-parent EventBus subscriptions cleaned up via hook')
        }
    }, [])
}